import { __PURPOSE_REDEMPTION__, __PURPOSE_CUSTOMIZED__, __PURPOSE_HK_CAMPAIGN__, __PURPOSE_EMAIL__, __PURPOSE_TRACKING__,__PURPOSE_CONTACT__,__PURPOSE_CANADA_CAMPAIGN__,__PURPOSE_ZENDESK__,__PURPOSE_CALL_EXPERT__ } from "@/const/formV3Purpose";

// 执行fnObj中对应用途的函数
export const useFormV3PurposeExecute = (purpose = '', fnObj = {}) => {
    const purposeMap = {
        [__PURPOSE_REDEMPTION__]: () => fnObj[__PURPOSE_REDEMPTION__]?.(),
        [__PURPOSE_CUSTOMIZED__]: () => fnObj[__PURPOSE_CUSTOMIZED__]?.(),
        [__PURPOSE_HK_CAMPAIGN__]: () => fnObj[__PURPOSE_HK_CAMPAIGN__]?.(),
        [__PURPOSE_EMAIL__]: () => fnObj[__PURPOSE_EMAIL__]?.(),
        [__PURPOSE_TRACKING__]: () => fnObj[__PURPOSE_TRACKING__]?.(),
        [__PURPOSE_CONTACT__]: () => fnObj[__PURPOSE_CONTACT__]?.(),
        [__PURPOSE_CANADA_CAMPAIGN__]: () => fnObj[__PURPOSE_CANADA_CAMPAIGN__]?.(),
        [__PURPOSE_ZENDESK__]: () => fnObj[__PURPOSE_ZENDESK__]?.(),
        [__PURPOSE_CALL_EXPERT__]: () => fnObj[__PURPOSE_CALL_EXPERT__]?.(),
    };

    return purposeMap[purpose]?.();
}